<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle" style="padding-top: 200px">
      <form @submit.prevent="login">
        <div class="form-box card-base card-shadow--extraLarge">
          <img class="image-logo" src="@/assets/images/LogoVF.png" alt="logo" />

          <float-label class="styled">
            <input
              type="text"
              placeholder="Username"
              v-model="form.username"
              required
            />
          </float-label>
          <float-label class="styled">
            <input
              type="password"
              placeholder="Password"
              v-model="form.password"
              required
            />
          </float-label>

          <div class="flex">
            <div class="box grow">
              <el-checkbox v-model="form.remember_me">{{
                $t("auth.login.remember_me")
              }}</el-checkbox>
            </div>
            <!-- <div class="box grow text-right">
              <router-link to="/forgot-password">
                {{ $t("auth.login.forgot_password") }}
              </router-link>
            </div>-->
          </div>

          <div class="flex text-center center pt-30 pb-10">
            <button
              type="submit"
              class="el-button login-btn tada animated el-button--primary el-button--small is-plain"
            >
              <span>{{ $t("auth.login.main") }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </vue-scroll>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      form: {
        username: "",
        password: "",
        remember_me: false
      }
    };
  },
  created() {
    // localStorage.clear();
    // sessionStorage.clear();
  },
  methods: {
    ...mapMutations({ setSplashScreen: "setSplashScreen" }),
    ...mapActions({ logout: "auth/logout" }),
    login() {
      const user = {
        username: this.form.username,
        password: this.form.password,
        remember_me: this.form.remember_me
      };

      this.$store
        .dispatch("auth/login", user)
        .then(() => {
          // Get User info
          this.$store.dispatch("user/userInfo").then((resp) => {
            const user = resp.data._userinfo;

            let error = false;
            if (user.Roles === null || user.Roles === undefined) {
              error = true;
              this.$message.error(
                "Su usuario no tiene rol asignado, por favor comuniquese con TI"
              );
            }

            if (
              user.CompanySelected === null ||
              user.CompanySelected === undefined ||
              user.CompanySelected == ""
            ) {
              error = true;
              this.$message.error(
                "Su usuario no tiene empresa asignado, por favor comuniquese con TI"
              );
            }

            if (error === false) {
              this.$router.push({ path: "/dashboard" });

              let body = document.body;
              body.classList.forEach((clas) => {
                if (clas.split("-")[0] === "theme") {
                  body.classList.replace(
                    clas,
                    `theme-${user.CompanySelected.toLowerCase()}`
                  );
                }
              });
            } else {
              localStorage.removeItem("vuex");
              this.logout();
              this.setSplashScreen(false);
            }
          });
        })
        .catch((error) => {
          this.$store.commit("setSplashScreen", false);

          if (error.response) {
            if (
              error.response.status &&
              ![401, 400, 403, 404].includes(error.response.status)
            ) {
              this.$message.error(error.message);
            }
          }
        });
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/_variables";

.login-page {
  // background: $text-color;
  margin-left: -30px;
  margin-right: -30px;

  .form-wrapper {
    width: 100%;
  }

  .form-box {
    width: 100%;
    max-width: 340px;
    padding: 30px;
    box-sizing: border-box;
    margin: 20px auto;

    a {
      font-size: 14px;
      color: $text-color-accent;
      text-decoration: none;
      font-weight: 500;
    }

    .image-logo {
      width: 50%;
      height: auto;
      margin: 0px auto;
      margin-bottom: 30px;
      display: block;
      object-fit: contain;
    }

    .login-btn,
    .social-btn {
      width: 160px;

      &.google {
        margin-bottom: 10px;
        background-color: #d73d32;
        color: white;

        &:hover {
          border-color: #d73d32;
        }
      }
      &.facebook {
        background-color: #3f5c9a;
        color: white;

        &:hover {
          border-color: #3f5c9a;
        }
      }
    }

    .signin-box {
      font-size: 14px;
    }
  }
}

@media (max-width: 768px) {
  .layout-container .container .view.login-page {
    margin-left: -5px;
    margin-right: -5px;
    max-width: calc(100% + 10px);
  }
}

.fullscreen-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: -100;
}

.fullscreen-bg__video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (min-aspect-ratio: 16/9) {
  .fullscreen-bg__video {
    height: 300%;
    top: -100%;
  }
}

@media (max-aspect-ratio: 16/9) {
  .fullscreen-bg__video {
    width: 300%;
    left: -100%;
  }
}

@media (max-width: 767px) {
  .fullscreen-bg {
    background: $text-color;
  }

  // .fullscreen-bg__video {
  //   display: none;
  // }
}
</style>
